// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"2827af77","854":"e13eb809"}[chunkId] + ".chunk.js";
};